export enum MerchantSubmissionStatus {
  Submitted = "submitted",
  Contacted = "contacted",
  Closed = "closed",
}
